import { Effectiveness } from './effectiveness';
import { ReportTypes } from '../report/report-types';

export interface EffectivenessViewModel {
  numberOfRespondents: number;
  numberOfCompleteResponses: number;
  ReportType: ReportTypes;
  effectiveness: Effectiveness[];
}
